export default {
    namespaced: true,
    state: {
        comment: '',
    },
    getters: {
        getComment(state) {
            return state.comment;
        },
    },
    mutations: {
        setComment(state, payload) {
            state.comment = payload;
        },
        clearComment(state) {
            state.comment = '';
        }
    },
}
